import script from "./AllEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./AllEvents.vue?vue&type=script&setup=true&lang=js"

import "./AllEvents.vue?vue&type=style&index=0&id=48648722&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48648722"]])

export default __exports__